import React, {useContext, useEffect, useState} from 'react';
import {useQueryClient} from "react-query";
import SystemContext from '../../../SystemContext';

import { FormDialog } from "../../../controls";
import AirportsLookup from '../../Airports/components/AirportsLookup';

const GetRouteEndpointDialog = (props) => {

  const classes = props.classes;
  const SystemData = useContext(SystemContext);
  const queryClient = useQueryClient();
  const eventBus = SystemData.eventBus;

  const [dialogState, setDialogState] = useState({
    showDialog: false,
    title: 'Final Destination',
    record: null
  });

  const DisplayForm = () => {
    return (
      <FormDialog
        title={dialogState.title}
        message="You can select a final destination for the route below if required."
        open={dialogState.showDialog}
        record={{finalDestinationAirportCode: "", finalDestinationAirportname: ""}}
        dialogOptions={{maxWidth: "sm", fullWidth: false}}
        classes={classes}
        buttons = {{
          continue:{icon: "check_circle", key: "Continue", label: "Continue", color: "primary", disabled: (status)=>{return status.error}},
          cancel:{icon: "cancel", key: "Cancel", label: "Cancel", color: "primary"}
        }}
        onChange={(state) => {
          if (state.buttonPressed === "continue") {
            const record = state.record;
            setDialogState({...dialogState, showDialog: false, record: null});
            if (typeof props.onChange === 'function') {
              props.onChange({record: dialogState.record, finalDestinationAirport: record.finalDestinationAirport});
            }
          } else {
            setDialogState({...dialogState, showDialog: false, record: null});
            if (typeof props.onClose === 'function') {
              props.onClose()
            }
          }
        }}
      >
        <div style={{display: "inline-block", width: 120}} checkChildren={true}>
          <AirportsLookup
            id="finalDestinationAirportCode"
            label="Final Destination"
            inputLabelProps={{ shrink: true }}
            fullWidth
            returnType="object"
            onChange={(returnObject, props)=>{
              if (returnObject.found) {
                const data = {
                  ...props.rowData,
                  finalDestinationAirportCode: returnObject.data.airportCode,
                  finalDestinationAirport: returnObject.data,
                }
                props.recordChange(data);
              } else {
                props.recordChange({finalDestinationAirportCode: returnObject.value, finalDestinationAirport: null});
              }
            }}
          />
        </div>
        {record => (
          <div style={{display: "inline-block", width: 300}} checkChildren={true}>
            {record?.finalDestinationAirport?.airportName}
          </div>
        )}
      </FormDialog>
    )
  }

  useEffect(()=> {
    const open = async (params) => {
      const {record} = params;
      setDialogState({...dialogState, showDialog:true, record});
    }
    eventBus.bind(`${props.eventPrefix}.open`, open);
    return () => {
      eventBus.unbind(`${props.eventPrefix}.open`, open);
    }
  }, [dialogState, eventBus, props.eventPrefix, queryClient]);

  if (dialogState.showDialog) {
    return (
      <DisplayForm />
    )
  }
  return (<></>);
}

export default GetRouteEndpointDialog;
